// extracted by mini-css-extract-plugin
module.exports = {"code_img":"code_img--1HJ_d","code_text":"code_text--2ugtN","code_item":"code_item--3ql2y"};